var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[(_vm.lista_permissoes_filial['ra_Filial'])?_c('div',{staticClass:"col-lg-12 col-xxl-12"},[_c('protocoloDestinatarios')],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }